<script>
import {mapState, mapActions, mapMutations} from "vuex";
import SideNav from './views/components/SideNav.vue';
import {JWTHelper} from "@/helpers/JWTHelper";
import QuickMenu from "@/views/components/QuickMenu.vue";
import QuickActionHost from "@/views/components/QuickActionHost.vue";
import TopBar from "@/views/components/TopBar.vue";
import TestEnvironmentBadge from "@/views/components/TestEnvironmentBadge.vue";
import AiDebuggerBubble from "@/views/components/aiDebugger/AiDebuggerBubble.vue";
import { setupCrisp } from "@/helpers/CrispHelper";
import { handlePageShortcut } from "@/helpers/pageShortcuts";

export default {
  name: 'App',
  components: {
    SideNav,
    TopBar,
    TestEnvironmentBadge,
    QuickMenu,
    QuickActionHost,
    AiDebuggerBubble
  },
  data() {
    return {
      user: null
    }
  },
  methods: {
      ...mapActions('account', {
          logout: 'logout',
          getMyData: 'getMyData'
      }),
      ...mapMutations('global', ['setExpanded']),
      submitLogout(){
          this.logout();
      },
      closeMobileSideNav(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        this.setExpanded(false);
      },
      updateDocumentTitle() {
        const orgId = this.user?.orgId ?? this.user?.organization?.orgId;
        document.title = orgId ? `Posbel - ${orgId}` : 'Posbel';
      }
  },
  watch: {
    'accountState.user': {
      immediate: true,
      handler(user) {
        if (!user) {
          document.title = 'Posbel';
          return;
        }
        this.user = user;
        this.updateDocumentTitle();
        setupCrisp(user);
      }
    }
  },
  computed: {
    ...mapState({
      accountState: 'account',
      globalState: 'global'
    }),
    isMobileSideNavOpen() {
      return this.accountState.isLoggedIn && this.globalState.isSideNavExpanded;
    }
  },
  mounted() {
    window.addEventListener('keydown', handlePageShortcut);
    this.updateDocumentTitle();
    if (!this.accountState.user && JWTHelper.isLoggedIn()) {
        this.getMyData();
    }
  },
  beforeUnmount() {
    window.removeEventListener('keydown', handlePageShortcut);
  }
}
</script>

<template class="main-content">
  <div
    v-if="isMobileSideNavOpen"
    class="side-nav-overlay d-md-none"
    @pointerdown.stop.prevent="closeMobileSideNav"
    @touchstart.stop.prevent="closeMobileSideNav"
    @click.stop.prevent="closeMobileSideNav"
  />
  <TestEnvironmentBadge />
  <side-nav v-if="accountState.isLoggedIn" id="side-nav" />
  <QuickMenu v-if="accountState.isLoggedIn" />
  <QuickActionHost v-if="accountState.isLoggedIn" />
  <AiDebuggerBubble v-if="accountState.isLoggedIn && accountState.isSuperUser && !isBlackbox()" />
  <div class="app-content">
    <TopBar v-if="accountState.isLoggedIn" />
    <router-view  v-slot="{ Component }">
      <transition name="rt-anim"  mode="out-in">
        <component class="main-router d-flex flex-column" :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<style lang="scss">
@import './assets/icons/fantasticon/icons.css';
.app-content {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-basis: 0;
  flex-grow: 999;
  min-width: 0;
  height: 100%;
}

.main-router {
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
}


.side-nav-overlay {
  position: fixed;
  inset: 0;
  background: transparent;
  z-index: 9998;
}

.rt-anim-move,
.rt-anim-enter-active,
.rt-anim-leave-active {
  transition: opacity 0.1s ease, transform 0.1s ease;
}
.rt-anim-enter-from,
.rt-anim-leave-to {
  opacity: 0;
  transform: translateY(30px);
}


</style>
